import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const selectConnections = state => state.connections.listed;

export function useConnections({ filter, sortBy: sortFunction } = {}) {
    const connections = useSelector(selectConnections);

    return useMemo(() => {
        let result = connections;

        if (filter) result = result.filter(filter);
        if (sortBy) result = sortBy(result, sortFunction);

        return result;
    }, [connections, filter, sortBy]);
}

